import React from 'react';
import AdminDrawer from './AdminDrawer';

export default function AdminPanel() {
  return (
    <div>
      <AdminDrawer />
    </div>
  );
}
